// Module
var code = `<div class="instx">{{info.instx}}</div>
<p class="h3 code-container-details-text-title">{{info.title}}</>
{{#info.body}}
<p class="code-container-details-text-body">{{.}}</p>
{{/info.body}}
`;
// Exports
module.exports = code;